import { Link } from "react-router-dom";
import { Calendar, Clock, MapPin, Video, Users, Star } from "lucide-react";

const formatDate = (d) => {
  if (!d) return "";
  try {
    return new Date(d + "T00:00:00").toLocaleDateString("en-US", { weekday: "short", month: "long", day: "numeric", year: "numeric" });
  } catch { return d; }
};

export const EventCard = ({ event, past }) => (
  <div className={`group flex flex-col bg-mahogany-800/60 gold-frame rounded-sm overflow-hidden shadow-[0_10px_40px_rgba(0,0,0,0.4)] transition-transform duration-500 hover:-translate-y-1 ${past ? "opacity-90" : ""}`} data-testid={`event-card-${event.id}`}>
    <div className="relative h-52 overflow-hidden">
      {event.image_url && <img src={event.image_url} alt={event.title} className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 ${past ? "grayscale-[30%]" : ""}`} />}
      <div className="absolute inset-0 bg-gradient-to-t from-mahogany-950/90 to-transparent" />
      <span className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.2em] text-mahogany-900 bg-gold px-3 py-1 rounded-full font-semibold">{event.type}</span>
      {event.featured && !past && <span className="absolute top-4 right-4 text-[10px] uppercase tracking-[0.15em] text-mahogany-900 bg-fuchsia text-white px-2.5 py-1 rounded-full font-semibold inline-flex items-center gap-1"><Star size={10} className="fill-white" /> Featured</span>}
      {past && <span className="absolute top-4 right-4 text-[10px] uppercase tracking-[0.15em] text-cream bg-mahogany-950/80 px-2.5 py-1 rounded-full">Past</span>}
    </div>
    <div className="p-6 flex flex-col flex-1">
      <h3 className="font-serif text-2xl text-cream leading-tight mb-3">{event.title}</h3>
      <div className="space-y-1.5 text-cream/70 text-sm mb-4">
        <p className="flex items-center gap-2"><Calendar size={14} className="text-gold" strokeWidth={1.5} /> {formatDate(event.date)}</p>
        {event.time && <p className="flex items-center gap-2"><Clock size={14} className="text-gold" strokeWidth={1.5} /> {event.time}{event.end_time ? ` – ${event.end_time}` : ""}</p>}
        {event.is_virtual ? (
          <p className="flex items-center gap-2"><Video size={14} className="text-gold" strokeWidth={1.5} /> Virtual Event</p>
        ) : event.location && (
          <p className="flex items-center gap-2"><MapPin size={14} className="text-gold" strokeWidth={1.5} /> {[event.location, event.city].filter(Boolean).join(", ")}</p>
        )}
      </div>
      <p className="text-cream/60 text-sm leading-relaxed line-clamp-3 mb-5 flex-1">{event.description}</p>
      <div className="flex items-center justify-between mt-auto">
        {event.rsvp_enabled ? (
          <span className="text-cream/50 text-xs flex items-center gap-1.5"><Users size={13} className="text-gold" /> {event.rsvp_count || 0}/{event.capacity} spots</span>
        ) : <span />}
        <Link to={`/events/${event.id}`} data-testid={`event-view-${event.id}`} className="text-fuchsia text-sm uppercase tracking-wider hover:text-gold transition-colors">{past ? "View →" : "Details & RSVP →"}</Link>
      </div>
    </div>
  </div>
);

export default EventCard;
